<template>
  <v-dialog v-model="visibility" persistent max-width="430" scrollable>
    <v-card v-if="visibility" rounded="xl">
      <v-card-title class="py-6">
        <h4 class="text-capitalize dialog-title">{{ t('$vuetify.__LeftBar.transfer_ai_data') }}</h4>
      </v-card-title>

      <v-card-subtitle class="pa-0 card-subtitle">
        {{ t('$vuetify.__LeftBar.transfer_from') }}: <span style="color: black">{{ source_device.raw.description }}</span>
      </v-card-subtitle>

      <v-card-text class="py-4">
        <v-form v-model="valid" ref="form">
          <v-row no-gutters>
            <v-col cols="12" class="selection-label">{{ t('$vuetify.__LeftBar.select_device') }}</v-col>
            <v-col cols="12" class="mt-2">
              <v-select
                :rules="dest_rules"
                variant="outlined"
                density="compact"
                hide-details="auto"
                menu-icon="mdi-chevron-down"
                :menu-props="{ bottom: true, offsetY: true }"
                :items="device_list"
                item-title="description"
                item-value="id"
                v-model="dest_id"
              />
            </v-col>
            <v-col class="mt-4" cols="12">
              <v-row no-gutters align="start">
                <v-col style="max-width: 30px"><v-icon>mdi-alert-circle</v-icon></v-col>
                <v-col class="black-small-text">{{ t('$vuetify.__LeftBar.transfer_hint') }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="ma-4">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" rounded class="text-capitalize px-3" @click="store.commit('RESET_TRANSFER_DEVICE_DATA_DIALOG')"> {{ t('$vuetify.__General.cancel') }} </v-btn>
        <v-btn variant="flat" color="#1B65F2" rounded class="text-capitalize px-3" @click="submit"> {{ t('$vuetify.__General.confirm') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useLocale } from 'vuetify'
const { t } = useLocale()
import { useStore } from 'vuex'
const store = useStore()
import { computed, ref } from 'vue'

const form = ref()
const valid = ref(false)
const dest_id = ref(null)
const dest_rules = ref([(v) => !!v || t('$vuetify.__Rules.destination_device')])

const visibility = computed(() => store.state.transferDeviceDataDialog.visibility)
const source_device = computed(() => store.state.transferDeviceDataDialog.source_device)
const device_list = computed(() => store.state.auth.device_list.filter((device) => device.id !== source_device.value.raw.id))

const submit = () => {
  form.value.validate()
  if (valid.value) {
    store.dispatch('transferDeviceData', { source_id: source_device.value.value, dest_id: dest_id.value })
  }
}
</script>

<style scoped>
.card-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #828282;
  padding: 12px 24px 12px 24px !important;
}
</style>
